import React, { useState, useEffect } from 'react';
import { Banner } from '../../interfaces/Banner.interface';
import RecipeOfTheDay from '../RecipeOfTheDay';
import './BannerCarousel.css';

interface BannerCarouselProps {
  banners: Banner[];
}

const BannerCarousel: React.FC<BannerCarouselProps> = ({ banners }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Function to handle next slide
  const handleNext = (e?: React.MouseEvent) => {
    if (e) e.stopPropagation();
    setCurrentIndex((prevIndex) => (prevIndex + 1) % banners.length);
  };

  // Function to handle previous slide
  const handlePrev = (e?: React.MouseEvent) => {
    if (e) e.stopPropagation();
    setCurrentIndex((prevIndex) => (prevIndex - 1 + banners.length) % banners.length);
  };

  // Cambiar la imagen automáticamente cada 10 segundos
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % banners.length);
    }, 10000); // 10000ms = 10s
    return () => clearInterval(interval);
  }, [banners.length]);

  // Obtener el banner actual
  const banner = banners[currentIndex];

  if (!banners || banners.length === 0) {
      return null;
  }

  return (
    <div className="banner-carousel-container">
      <button className="banner-carousel-arrow banner-left" onClick={handlePrev} aria-label="Anterior">
        &#10094;
      </button>

      <RecipeOfTheDay
        banner={banner}
      />

      <button className="banner-carousel-arrow banner-right" onClick={handleNext} aria-label="Siguiente">
        &#10095;
      </button>
    </div>
  );
};

export default BannerCarousel;
